import { c as _c } from "react/compiler-runtime";
import type { DetailContentInfo } from '__generated__/api/unauth';
import { cn } from '@core/utils';
import { TABS } from '../../../../constants';
import { Contents } from './_components/Contents';
import { Notice } from './_components/Notice';
import { StaticBanner } from './_components/StaticBanner';
interface GiftTabContentBasicProps {
  detailContentInfoList: DetailContentInfo[];
  noticeContents?: string;
  noticeTitle?: string;
  productName?: string;
}
export const GiftTabContentBasic = t0 => {
  const $ = _c(11);
  const {
    detailContentInfoList,
    noticeContents,
    noticeTitle,
    productName
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("flex flex-col border-1 border-Gray-300", "mobile-tablet:border-0");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== noticeContents || $[2] !== noticeTitle || $[3] !== productName) {
    t2 = noticeTitle && noticeContents ? <Notice content={noticeContents} productName={productName} title={noticeTitle} /> : null;
    $[1] = noticeContents;
    $[2] = noticeTitle;
    $[3] = productName;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <StaticBanner />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== detailContentInfoList) {
    t4 = <Contents detailContentInfoList={detailContentInfoList} />;
    $[6] = detailContentInfoList;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = <section id={TABS.BASIC} className={t1}>{t2}{t3}{t4}</section>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};